export default __webpack_public_path__ + "static/media/Guru-Parampara-31.55f9bf42.png";